import { useMutation, useQueryClient } from '@tanstack/react-query';
import { signatureRegistrationMutationFn } from '@/modules/Dashboard/queries/sidebarSignature/signatureRegistrationMutationFn.ts';
import { userInfoQueryOptions } from '@/common/queries/userInfo/userInfoQueryOptions.ts';
import { getAdjusterSignatureQueryOptions } from '@/modules/Dashboard/queries/sidebarSignature/getAdjusterSignatureQueryOptions.ts';

const useSignatureRegisterMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: signatureRegistrationMutationFn,
    meta: {
      successToast: 'امضا شما با موفقیت ثبت شد !',
    },
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: getAdjusterSignatureQueryOptions().queryKey,
      });
      return queryClient.invalidateQueries({
        queryKey: userInfoQueryOptions().queryKey,
      });
    },
  });
};

export default useSignatureRegisterMutation;
